import { createRoot } from 'react-dom/client';
import { App } from 'App';

import * as Sentry from '@sentry/react';
// import './wdyr';

if (process.env.NODE_ENV !== 'development') {
	Sentry.init({
		dsn: 'https://7547e40208f22331acf7c07502d7568e@o4509814567141376.ingest.de.sentry.io/4509814585622608',
		// Setting this option to true will send default PII data to Sentry.
		// For example, automatic IP address collection on events
		sendDefaultPii: true,
		enableLogs: true,
		// environment: 'development',
	});
}

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);
